module.exports = __webpack_public_path__ + "img/add.c443278d.svg";